import {
	AttacherSolver,
	SubsolutionEvaluator,
	SubsolutionEvaluators,
} from "@animech/supermodel";
import { getPartialVectorLength } from "./utility";
import { entityNames } from "./constants";
import { AttacherSolverContext } from "./attacher-solver-context";

type CustomSubsolutionEvaluator = (
	...args: [
		...Parameters<SubsolutionEvaluator>,
		context: Readonly<AttacherSolverContext>,
	]
) => ReturnType<SubsolutionEvaluator>;

const prefer = {
	numerousContactPoints: (s) =>
		s.activeInstances.reduce(
			(result, activeInstance) =>
				result +
				activeInstance.attachments.reduce((result, attachment) => {
					return (
						result + (attachment.entity.name !== entityNames.floor ? 1 : 0)
					);
				}, 0),
			0,
		),
	shortOffsets: (s) =>
		-s.entityTransforms.reduce(
			(result, entityTransform) =>
				result +
				getPartialVectorLength(
					entityTransform.deltaPosition,
					true,
					false,
					true,
				),
			0,
		),
	shortRotations: (s) =>
		-s.entityTransforms.reduce(
			(result, entityTransform) =>
				result +
				Math.abs(
					AttacherSolver.getRotationAngle(entityTransform.deltaRotation),
				),
			0,
		),
} as const satisfies Record<string, CustomSubsolutionEvaluator>;

export function createSubsolutionEvaluators(
	context: AttacherSolverContext,
): SubsolutionEvaluators {
	return (_entityTree) =>
		[
			prefer.numerousContactPoints,
			prefer.shortOffsets,
			prefer.shortRotations,
		].map((e: CustomSubsolutionEvaluator) => (s) => e(s, context));
}
